const API_BASE_URL = "https://api.supremekingapp.com";

export default API_BASE_URL;
